import React, { useEffect, useState } from "react"
import { Modal } from 'react-bootstrap'

import { formatDate } from 'helpers/helpers'
import { httpOk, POST } from 'helpers/api'

// Клиенту нужны оба пути сразу: бот в его группе может как быть, так и не быть
export function telegramClientMessage(link) {
	return 'Подключение Telegram-группы к Mison:\n\n'
		+ '1) Откройте ссылку и выберите свою группу — бот войдёт в неё сам:\n'
		+ link.link + '\n\n'
		+ '2) Если бот уже есть в группе, просто отправьте в неё команду:\n'
		+ link.command + '\n\n'
		+ 'Код действует ' + (link.ttl_minutes || 60) + ' минут и срабатывает один раз.'
}

// Ссылка подключения группы для одной точки. Код выписывается на бренд точки
// (группа привязывается к login), а не на того, кто нажал кнопку.
function ModalPosTelegramLink({ show, onHide, posItem, url }) {
	const [link, setLink] = useState(null)
	const [copied, setCopied] = useState('')

	async function createLink() {
		const response = await POST(url, {
			pos_id: posItem.id,
		}, { loader: true, notification: false })
		if (httpOk(response)) {
			setLink(response.data)
		} else {
			onHide()
		}
	}

	function copyText(text, mark) {
		navigator.clipboard.writeText(text)
		setCopied(mark)
	}

	useEffect(() => {
		setLink(null)
		setCopied('')
		if (show && posItem?.id) createLink()
	}, [show]) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<Modal show={show && !!link} animation={false} centered size="lg"
			onHide={onHide}>
			<Modal.Header closeButton>
				<Modal.Title>Telegram-группа — {posItem?.name || posItem?.login}</Modal.Title>
			</Modal.Header>
			<Modal.Body style={{ fontSize: 13 }}>
				<div className="text-muted mb-2">
					Отправьте ссылку клиенту: он откроет её и выберет свою группу — бот войдёт туда
					и привяжет группу к бренду <b>{link?.login}</b> (все его точки).
					Код действует до {formatDate(link?.expires_at, 'dd.MM.yyyy HH:mm')} и срабатывает один раз.
				</div>
				<div className="d-flex flex-wrap align-items-center gap-2">
					<input type="text" readOnly className="form-control form-control-sm"
						style={{ flex: '1 1 420px' }} value={link?.link || ''}
						onFocus={(e) => e.target.select()} />
					<button type="button" className="btn btn-sm btn-primary"
						onClick={() => copyText(telegramClientMessage(link), 'message')}>
						{copied === 'message' ? 'Скопировано' : 'Копировать сообщение клиенту'}
					</button>
					<button type="button" className="btn btn-sm btn-outline-primary"
						onClick={() => copyText(link.link, 'link')}>
						{copied === 'link' ? 'Скопировано' : 'Только ссылка'}
					</button>
					<a className="btn btn-sm btn-outline-secondary" href={link?.link}
						target="_blank" rel="noreferrer">
						Открыть
					</a>
				</div>
				<div className="text-muted mt-2">
					Если бот уже сидит в группе клиента, достаточно отправить туда команду <code>{link?.command}</code>.
				</div>
			</Modal.Body>
		</Modal>
	)
}

export default ModalPosTelegramLink
